export const SWITCHER_STATES = {
    LOGO_SERVICES: 'logo_services',
    LOGO_MAKER: 'logo_maker',
};

export const LISTING_SOURCES = {
    SEARCH: 'search',
    SUBCATEGORY: 'subcategory',
};
